<div *ngIf="isEditMode; else readModeBlock" class="edit-mode">
  <form [formGroup]="editForm">
    <span matLine class="label">{{ label }}</span>
    <div class="button-container">
      <button
        mat-flat-button
        color="primary"
        (click)="onSaveClicked()"
        [disabled]="!(editForm.valid && editForm.dirty)"
      >
        <mat-icon [ngClass]="showSmallIcons ? 'md-18' : ''">check</mat-icon> Save
      </button>
      <button type="button" mat-stroked-button (click)="toggleEditMode(false)">
        <mat-icon [ngClass]="showSmallIcons ? 'md-18' : ''">close</mat-icon> Cancel
      </button>
    </div>
    <mat-form-field appearance="outline" class="value-description">
      <input #description matInput type="text" formControlName="description" />
      <mat-error *ngIf="editForm.get('description').hasError('unique')">
        {{ editForm.get('description').getError('unique') }}
      </mat-error>
      <mat-error *ngIf="editForm?.get('description').hasError('required')">
        The {{ this.fieldName }} is required.
      </mat-error>
      <mat-error *ngIf="editForm?.get('description').hasError('email')">
        The {{ this.fieldName }} has to be a valid email.
      </mat-error>
      <mat-error *ngIf="editForm?.get('description').hasError('urlPattern')">
        The {{ this.fieldName }} has to be a valid url.
      </mat-error>
      <mat-error *ngFor="let error of editForm?.get('description').errors | keyvalue">
        <ng-container *ngIf="!['unique', 'required', 'email', 'urlPattern'].includes(error.key)">
          {{ error.value }}
        </ng-container>
      </mat-error>
    </mat-form-field>
  </form>
</div>

<ng-template #readModeBlock>
  <div class="read-mode" [ngClass]="!allowCreate() ? 'hovering' : ''" (click)="allowCreate() && toggleEditMode(true)">
    <span matLine class="label">{{ label }}</span>
    <span *ngIf="subText" class="subText">{{ subText }}</span>
    <div class="value-description">
      <span *ngIf="description">{{ description }}</span>
      <span *ngIf="allowCreate()" class="add" matLine>Click to add</span>
    </div>
    <div class="button-container" *ngIf="!readOnly">
      <button *ngIf="!allowCreate()" mat-stroked-button (click)="toggleEditMode(true)" aria-label="Edit">
        <mat-icon [ngClass]="showSmallIcons ? 'md-18' : ''">edit</mat-icon> Edit
      </button>
      <button *ngIf="allowDelete() && !allowCreate()" mat-icon-button (click)="onDeleteClicked()" aria-label="Delete">
        <mat-icon [ngClass]="showSmallIcons ? 'md-18' : ''">delete</mat-icon>
      </button>
    </div>
  </div>
</ng-template>
